import { View, Text } from "react-native";
import React, { useEffect, useState } from "react";
import FAQ from "../../api/get/FAQVideo";
import { Video, ResizeMode } from "expo-av";
import { width } from "../../imports";
import { Platform } from "react-native";
import { useRef } from "react";
import MyVideo from "../../components/MyVideo";
import MyText from "../custom/MyText";
import { primary, white } from "../../colors";
import translate from "../../functions/translate";

export default function FAQVideo() {
  const [video, setVideo] = useState(null);
 

  useEffect(() => {
    FAQ().then(({ data }) => {
      //console.log(data);
      if (data.data === undefined || data.data === null || data.data === "") {
      } else {
        setVideo(data.data);
      }
    });
  }, []);
  const onFullscreenUpdate = async ({ fullscreenUpdate }) => {
    switch (fullscreenUpdate) {
      case 1 || 0:
        await ScreenOrientation.unlockAsync().catch((error) => {}); // only on Android required
        break;
      case 2 || 3:
        await ScreenOrientation.lockAsync(
          ScreenOrientation.OrientationLock.PORTRAIT
        ).catch((error) => {}); // only on Android required
        break;
    }
  };
  return video !== null ? (
    <View style={{ width: "94%" }}>
      <View
        style={{
          width: "100%",
          borderRadius: 10,
          backgroundColor: primary,
          padding: 10,
        }}
      >
        <MyText style={{ fontSize: 20, color: white }}>
          {translate('how to use this app')}
        </MyText>
      </View>
      <View
        style={{
          borderRadius: 10,
          marginTop: -15,
          padding: 10,
          paddingTop: 25,
          borderWidth: 1,
          borderColor: primary,
          width: "100%",
        }}
      >
        <MyVideo url={video} />
      </View>
    </View>
  ) : (
    <></>
  );
}
